import { render, staticRenderFns } from "./roam-bin-movement-v1.vue?vue&type=template&id=2523cdc5&"
import script from "./roam-bin-movement-v1.vue?vue&type=script&lang=js&"
export * from "./roam-bin-movement-v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports